
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Coupleresortinnagpurdistricinjungle() {



  const cardData =
  {
    keyword: ' Couple Resort in Nagpur District in Jungle',
    heading:  'Woodland Escape: Couple Resort in Nagpur District in Jungle ',
    headingDescription: 'Woodland Escape Resort is an inviting couple resort in Nagpur District in a jungle setting, designed for tranquil escapes and intimate moments amid nature. Tucked away within a forest-fringed landscape in the Nagpur area, the resort offers charming cottages with private verandas, serene walking trails through rich greenery and secluded spots perfect for two. Couples can enjoy romantic breakfasts on the lawn, sunset strolls among trees, and candle-lit dinners under the stars—all in the peaceful ambience of a natural ret­reat. With warm hospitality, thoughtful amenities, and a blend of wilderness and comfort, Woodland Escape Resort provides the ideal backdrop for a memorable and romantic getaway.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Couple Resort in Nagpur District in Jungle",
      "description": "Escape to a serene jungle retreat at this Nagpur couple resort, surrounded by lush forests and natural beauty. Designed for privacy and romance, the resort offers cozy cottages, scenic walking trails, and intimate dining experiences. Couples can enjoy riverside picnics, guided nature walks, and evening bonfires under the stars. Perfect for romantic getaways, anniversaries, or pre-wedding shoots, this resort combines adventure and tranquility in a unique jungle setting."
    },
    {
      "name": "Nagpur Jungle Romantic Resort",
      "description": "Immerse yourself in nature at Nagpur Jungle Romantic Resort, an ideal destination for couples seeking privacy, adventure, and serenity. The resort offers private cottages, forest-view decks, and romantic dining experiences. Couples can participate in guided treks, birdwatching, and outdoor adventure activities while enjoying the peaceful jungle environment. Evening bonfires and starlit walks create memorable moments for a truly romantic getaway."
    },
    {
      "name": "Nagpur Nature Couple Stay",
      "description": "Reconnect with your partner amidst nature at Nagpur Nature Couple Stay. The resort features eco-friendly cottages, riverside seating, and scenic viewpoints perfect for couple photography. Guests can explore hiking trails, relax in hammocks by the river, and enjoy curated nature activities together. With a focus on comfort, privacy, and natural beauty, this resort is ideal for couples wanting a mix of relaxation, adventure, and romance."
    },
    {
      "name": "Nagpur Private Couple Resort",
      "description": "Enjoy ultimate privacy at Nagpur Private Couple Resort, offering secluded cottages and exclusive spaces surrounded by greenery. The resort provides personalized services, intimate dining options, and romantic setups for special occasions. Couples can experience nature walks, river-side evenings, and adventure activities while enjoying the peaceful jungle ambiance. Perfect for anniversaries, honeymoon trips, or weekend romantic escapes."
    },
    {
      "name": "Nagpur Eco-Friendly Romantic Resort",
      "description": "Stay sustainably at Nagpur Eco-Friendly Romantic Resort, where green living meets luxury and romance. The resort emphasizes eco-conscious practices with solar energy, organic gardens, and minimal-impact accommodations. Couples can enjoy nature trails, wildlife spotting, riverside lounging, and evening bonfires. Ideal for environmentally-conscious travelers who want a memorable romantic getaway in harmony with nature."
    },
    {
      "name": "Nagpur Jungle Luxury Resort",
      "description": "Indulge in a luxurious jungle retreat at Nagpur Jungle Luxury Resort, featuring premium cottages, private decks, and upscale amenities. Couples can relax with spa treatments, enjoy gourmet meals in scenic surroundings, and partake in curated jungle adventures like treks, birdwatching, and riverside activities. Perfect for those seeking a romantic getaway that combines comfort, privacy, and immersive nature experiences."
    },
    {
      "name": "Nagpur Adventure Couple Resort",
      "description": "For couples who love adventure, Nagpur Adventure Couple Resort offers activities like jungle trekking, zip-lining, kayaking, and guided wildlife tours. Accommodations are comfortable yet close to nature, providing a safe and fun environment for couples to bond through shared experiences. Evening campfires and riverside picnics add to the romantic and adventurous ambiance of the resort."
    },
    {
      "name": "Nagpur Riverside Romantic Resort",
      "description": "Experience romance by the river at Nagpur Riverside Romantic Resort. Couples can enjoy private riverside cottages, boating, fishing, and riverside picnics. The resort also offers scenic walking paths, evening bonfires, and starlit dinners by the water. Ideal for couples seeking tranquility, adventure, and a unique romantic experience amidst natural surroundings."
    },
    {
      "name": "Nagpur Hill Couple Resort",
      "description": "Escape to the hills at Nagpur Hill Couple Resort, where panoramic views and peaceful surroundings set the perfect romantic scene. Couples can enjoy hilltop treks, nature walks, birdwatching, and cozy private accommodations. The resort also provides intimate dining setups, bonfire evenings, and photo-friendly spots for couples. Perfect for honeymooners, anniversaries, or weekend escapes with breathtaking hill views."
    },
    {
      "name": "Nagpur Booking for Couple Resort",
      "description": "Secure your romantic getaway easily with Nagpur Booking for Couple Resort. Choose from a variety of jungle cottages, hilltop stays, and riverside accommodations tailored for couples. Online booking offers convenience, flexible packages, and special deals for anniversaries, pre-wedding shoots, or weekend retreats. Plan your intimate escape with ease and confidence at a resort designed for couples."
    },
    {
      "name": "Nagpur Outdoor Couple Stay",
      "description": "Enjoy an immersive outdoor experience at Nagpur Outdoor Couple Stay, surrounded by lush forests, rivers, and hills. The resort provides adventure and nature activities for couples, including hiking, boating, cycling, and wildlife spotting. Cozy private accommodations, scenic viewpoints, and evening bonfires make this resort ideal for couples who love exploring and relaxing in a natural environment."
    },
    {
      "name": "Nagpur Weekend Couple Resort",
      "description": "Perfect for a quick romantic escape, Nagpur Weekend Couple Resort offers tailored weekend packages for couples. Guests can enjoy nature trails, riverside picnics, adventure activities, and intimate dinners. Comfortable accommodations with jungle or river views ensure a relaxing stay. Ideal for reconnecting, celebrating special occasions, or simply spending quality time together in a serene setting."
    },
    {
      "name": "Nagpur Romantic Getaway in Jungle",
      "description": "Plan a magical romantic getaway at Nagpur Romantic Getaway in Jungle, offering secluded cottages, scenic walking trails, and outdoor adventure activities. Couples can enjoy private dining experiences, riverside relaxation, and evening bonfires under the stars. The resort ensures a perfect balance of romance, adventure, and tranquility for a memorable couple retreat amidst nature."
    },
    {
      "name": "Nagpur Nature Stay for Couples",
      "description": "Reconnect with nature and each other at Nagpur Nature Stay for Couples. The resort features eco-friendly accommodations, riverside decks, and hilltop viewpoints. Couples can enjoy guided treks, wildlife spotting, and intimate picnic setups. With a focus on comfort, privacy, and scenic beauty, this resort offers the ideal setting for romantic getaways, pre-wedding shoots, and weekend retreats."
    },
    {
      "name": "Nagpur Pre-Wedding Couple Resort",
      "description": "Ideal for pre-wedding photoshoots and romantic celebrations, Nagpur Pre-Wedding Couple Resort offers picturesque locations, scenic backdrops, and private accommodations. Couples can enjoy riverside strolls, forest trails, hilltop viewpoints, and curated nature experiences. Professional assistance for photography setups ensures a seamless and memorable pre-wedding experience amidst lush natural surroundings."
    }
  ],
  "tableData": [
    ["- Couple Resort in Nagpur District in Jungle", "- Nagpur Jungle Romantic Resort"],
    ["- Nagpur Nature Couple Stay", "- Nagpur Private Couple Resort"],
    ["- Nagpur Eco-Friendly Romantic Resort", "- Nagpur Jungle Luxury Resort"],
    ["- Nagpur Adventure Couple Resort", "- Nagpur Riverside Romantic Resort"],
    ["- Nagpur Hill Couple Resort", "- Nagpur Booking for Couple Resort"],
    ["- Nagpur Outdoor Couple Stay", "- Nagpur Weekend Couple Resort"],
    ["- Nagpur Romantic Getaway in Jungle", "- Nagpur Nature Stay for Couples"],
    ["- Nagpur Pre-Wedding Couple Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Romantic Jungle Retreat in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort offers a serene and secluded jungle setting, perfect for couples seeking privacy and tranquility. Surrounded by lush greenery and dense forests, it provides an intimate escape from the hustle of city life."
  },
  {
    "WhyChooseheading": "Cozy and Private Accommodation",
    "WhyChoosedescription": "The resort features well-designed rooms and cottages that offer comfort, privacy, and scenic jungle views. Couples can enjoy cozy interiors, modern amenities, and the soothing sounds of nature right outside their window."
  },
  {
    "WhyChooseheading": "Nature Walks and Romantic Trails",
    "WhyChoosedescription": "Couples can explore quiet nature trails, hand-in-hand, and enjoy the flora and fauna of the surrounding jungle. The serene walking paths and shaded areas create the perfect ambiance for romance and relaxation."
  },
  {
    "WhyChooseheading": "Peaceful and Intimate Ambience",
    "WhyChoosedescription": "Woodland Escape Resort ensures a calm and tranquil atmosphere, making it ideal for couples to unwind. The gentle rustle of trees, bird songs, and forest scents enhance the romantic jungle experience."
  },
  {
    "WhyChooseheading": "Outdoor and Leisure Activities",
    "WhyChoosedescription": "From guided jungle walks to cycling and pond-side relaxation, couples can choose activities that suit their mood. The resort blends adventure and leisure, creating memorable experiences together."
  },
  {
    "WhyChooseheading": "Delicious Meals for Two",
    "WhyChoosedescription": "Enjoy freshly prepared local and continental meals in the midst of nature. Couples can have intimate dining experiences at the resort’s outdoor or private seating areas, making every meal special."
  },
  {
    "WhyChooseheading": "Accessible Yet Secluded",
    "WhyChoosedescription": "Located within Nagpur District, Woodland Escape Resort offers the perfect balance of accessibility and seclusion. Couples can reach the resort conveniently while still feeling completely immersed in a jungle getaway."
  }
]




























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a jungle‑resort for couples in Nagpur district?",
    answer: "Woodland Escape Resort offers a secluded and romantic retreat in a jungle‑setting within Nagpur district. With lush greenery, peaceful surroundings and intimate spaces, it’s perfect for couples seeking a nature‑immersed getaway."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within comfortable driving distance from Nagpur city, making it convenient for couples to escape urban life and reach a tranquil jungle‑setting easily."
  },
  {
    question: "What facilities does Woodland Escape Resort provide for a couple’s jungle stay?",
    answer: "The resort offers well‑appointed rooms or cottages with nature views, private balconies or sit‑out zones, scenic walking trails, open lawns, and dedicated spaces for couples to unwind in a jungle environment."
  },
  {
    question: "Is Woodland Escape Resort suitable for couples wanting privacy and nature together?",
    answer: "Absolutely! The resort is designed to cater to couples wanting privacy, nature and comfort. With safe surroundings, fewer people around and natural settings, couples can enjoy quality time together."
  },
  {
    question: "Does the resort provide food and services tailored for couple stays in a jungle setting?",
    answer: "Yes—Woodland Escape Resort offers freshly prepared meals, snacks and beverages along with services such as candle‑light dinners, nature walks, and other amenities to create a memorable couple stay amidst jungle surroundings."
  },
  {
    question: "How can we book Woodland Escape Resort for a couple’s jungle stay in Nagpur district?",
    answer: "Booking can be done by calling or WhatsApp messaging the resort’s reservation team, or via the official website. Advance booking is recommended, especially during weekends and holiday periods."
  }
];

const testimonials = [
  {
    name: "Mr. & Mrs. Sharma, Nagpur",
    text: "Our stay at Woodland Escape Resort was simply magical! Surrounded by trees, the quiet trails and cozy room made our weekend unforgettable. Perfect for couples wanting a jungle escape in Nagpur."
  },
  {
    name: "Ms. Anjali & Mr. Rohan, Nagpur",
    text: "Woodland Escape Resort exceeded all our expectations. The nature‑filled setting, peace and romantic ambiance made our stay truly special. Highly recommended for couples in Nagpur district!"
  }
];

































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Couple Resort in Nagpur District in Jungle",
  "image": "https://woodlandescape.com/assets/images/nagpur-jungle-couple-resort.jpg",
  "description": "Escape to our Nagpur Jungle Romantic Resort, designed for couples seeking privacy and a luxurious nature retreat. Enjoy eco-friendly stays, riverside views, hilltop settings, and adventure activities amidst lush greenery.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "37"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-jungle-couple-resort"
  }
};



  return (
    <div>
<Helmet>
  <title>Couple Resort in Nagpur District in Jungle | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Discover the perfect romantic getaway at Nagpur Jungle Couple Resort. Enjoy privacy, luxurious eco-friendly stays, riverside and hilltop views, adventure activities, and nature retreats for couples." 
  />
  <meta 
    name="keywords" 
    content="Couple Resort in Nagpur District in Jungle, Nagpur Jungle Romantic Resort, Nagpur Nature Couple Stay, Nagpur Private Couple Resort, Nagpur Eco-Friendly Romantic Resort, Nagpur Jungle Luxury Resort, Nagpur Adventure Couple Resort, Nagpur Riverside Romantic Resort, Nagpur Hill Couple Resort, Nagpur Booking for Couple Resort, Nagpur Outdoor Couple Stay, Nagpur Weekend Couple Resort, Nagpur Romantic Getaway in Jungle, Nagpur Nature Stay for Couples, Nagpur Pre-Wedding Couple Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/51.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Coupleresortinnagpurdistricinjungle;